import { render } from "./TimetablePage.vue?vue&type=template&id=22167382&scoped=true"
import script from "./TimetablePage.vue?vue&type=script&lang=js"
export * from "./TimetablePage.vue?vue&type=script&lang=js"

import "./TimetablePage.vue?vue&type=style&index=0&id=22167382&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22167382"]])

export default __exports__